import {
    // FILE_UPLOAD,
    CREATE_ADMIN_EMERGENCY_ALERT,
    RETRIEVE_ADMIN_EMERGENCY_ALERT,
    // RETRIEVE_ARCHITECTURECOMPANYCONVERTEDLEADS,
    // RETRIEVE_ARCHITECTURECOMPANYPENDINGLEADS,
    RETRIEVESINGLE_ADMIN_EMERGENCY_ALERT,
    UPDATE_ADMIN_EMERGENCY_ALERT,
    DELETE_ADMIN_EMERGENCY_ALERT,
    // RETRIEVE_ARCHITECTURESERVERSTAFF,
    // RETRIEVE_ARCHITECTURESERVERSERVICEUSERS,
} from "./type";
import AdminEmergencyAlert from "../service/AdminEmergencyAlert";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await AdminEmergencyAlert.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await AdminEmergencyAlert.create(data);
        dispatch({
            type: CREATE_ADMIN_EMERGENCY_ALERT,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await AdminEmergencyAlert.fetchList(data);
        dispatch({
            type: RETRIEVE_ADMIN_EMERGENCY_ALERT,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await AdminEmergencyAlert.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_ADMIN_EMERGENCY_ALERT,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await AdminEmergencyAlert.update(data);
        dispatch({
            type: UPDATE_ADMIN_EMERGENCY_ALERT,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await AdminEmergencyAlert.changeStatus(data);
//         dispatch({
//             type: UPDATE_ADMIN_EMERGENCY_ALERT,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await AdminEmergencyAlert.trash(data);
        dispatch({
            type: DELETE_ADMIN_EMERGENCY_ALERT,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};